/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
const API_PATH = 'api';
const ADMIN_API_PATH = API_PATH + '/admin';
const AUTH_API_PATH = API_PATH + '/auth';

export const Configuration = {
    /**
     * Path to the endpoint for the management of access profiles.
     *
     * @var {String}
     */
    ACCESS_PROFILE_PATH: ADMIN_API_PATH + '/access-profile/:id',
    /**
     * Path to the endpoint for the management of accounts.
     *
     * @var {String}
     */
    ACCOUNT_PATH: ADMIN_API_PATH + '/account/:id',
    /**
     * Path to the endpoint for the management of action requests.
     *
     * @var {String}
     */
    ACTION_REQUEST_PATH: ADMIN_API_PATH + '/action-request/:id',
    /**
     * Path to the endpoint for the management of action requests prog mes.
     *
     * @var {String}
     */
    ACTION_REQUEST_PROG_MES_PATH: ADMIN_API_PATH + '/action-request-prog-mes/:id',
    /**
     * Path to the endpoint for the management of action request service level.
     *
     * @var {String}
     */
    ACTION_REQUEST_SERVICE_LEVEL_PATH: ADMIN_API_PATH + '/action-request-service-level/:id',
    /**
     * Path to the endpoint for the management of action request state before.
     *
     * @var {String}
     */
    ACTION_REQUEST_STATE_BEFORE_PATH: ADMIN_API_PATH + '/action-request-state-before/:id',
    /**
     * Path to the endpoint for the management of action request state after.
     *
     * @var {String}
     */
    ACTION_REQUEST_STATE_AFTER_PATH: ADMIN_API_PATH + '/action-request-state-after/:id',
    /**
     * Path to the endpoint for the management of action request symptom.
     *
     * @var {String}
     */
    ACTION_REQUEST_SYMPTOM_PATH: ADMIN_API_PATH + '/action-request-symptom/:id',
    /**
     * Path to the endpoint for the management of alarm codes.
     *
     * @var {String}
     */
    ALARM_CODE_PATH: ADMIN_API_PATH + '/alarm-code/:id',
    /**
     * Path to the endpoint for the management of alarms.
     *
     * @var {String}
     */
    ALARM_PATH: ADMIN_API_PATH + '/alarm/:id',
    /**
     * Path to the endpoint for the management of alarm sources.
     *
     * @var {String}
     */
    ALARM_SOURCE_PATH: ADMIN_API_PATH + '/alarm-source/:id',
    /**
     * Path to the endpoint for the management of types of alarm.
     *
     * @var {String}
     */
    ALARM_TYPE_PATH: ADMIN_API_PATH + '/alarm-type/:id',
    /**
     * Key used to store the session data in the browser' session storage.
     *
     * @var {String}
     */
    AUTH_STORAGE_KEY: 'auth-session',
    /**
     * Path to the endpoint for information about the app like version, spring profiles...
     *
     */
    APPLICATION_INFO: '/actuator/info',
    /**
     * Base path of the application.
     *
     * @var {String}
     */
    BASE_PATH: angular.element(document.getElementsByTagName('BASE')).attr('href'),
    /**
     * Path to the endpoint to perform a bulk operation on multiple entities at once.
     *
     * @var {String}
     */
    BULK_PATH: '/bulk',
    /**
     * Path to the endpoint to cancel an action request.
     *
     * @var {String}
     */
    CANCEL_ACTION_REQUEST_PATH: '/cancel',
    /**
     * Path to the endpoint for the management of causes.
     *
     * @var {String}
     */
    CAUSE_PATH: ADMIN_API_PATH + '/cause/:id',
    /**
     * Path to the endpoint for the management of origins.
     *
     * @var {String}
     */
    ORIGIN_PATH: ADMIN_API_PATH + '/origin/:id',
    /**
     * Path to the endpoint for the management of categories.
     *
     * @var {String}
     */
    CATEGORY_PATH: ADMIN_API_PATH + '/category/:id',
    /**
     * Path to the endpoint for the management of attributes.
     *
     * @var {String}
     */
    ATTRIBUTE_PATH: ADMIN_API_PATH + '/attribute/:id',
    /**
     * Colors fort charts.
     *
     * @var {Object}
     */
    CHART_COLORS: {
        DEFAULT_COLOR: '#00003F',
        ACTION_REQUEST_OPENED: '#FF0000',
        ACTION_REQUEST_COMPLETED: '#00003F',
        ACTION_REQUEST_CLOSED: '#007F00',
        ACTION_REQUEST_CANCELED: '#3F3F3F',
        PREVENTIVE_SHEET_OPENED: '#FF0000',
        PREVENTIVE_SHEET_COMPLETED: '#007F00',
        PREVENTIVE_SHEET_TOTAL_OPENED: '#3F3F3F'
    },
    /**
     * Sub-path to retrieve chart data.
     *
     * @var {String}
     */
    CHART_DATA_PATH: '/chart-data/:type',
    /**
     * Path to the endpoint to close an action request.
     *
     * @var {String}
     */
    CLOSE_ACTION_REQUEST_PATH: '/close',
    /**
     * Path to the endpoint for the management of companies.
     *
     * @var {String}
     */
    COMPANY_PATH: ADMIN_API_PATH + '/company/:id',
    /**
     * Path to the endpoint to complete an action request.
     *
     * @var {String}
     */
    COMPLETE_ACTION_REQUEST_PATH: '/complete',
    /**
     * Name of the cookie holding the CSRF token.
     *
     * @var {String}
     */
    CSRF_COOKIE_NAME: 'XSRF-TOKEN',
    /**
     * Path to the endpoint for the management of action requests.
     *
     * @var {String}
     */
    CURATIVE_ACTION_PATH: ADMIN_API_PATH + '/action-request/:actionRequestId/curative-action/:id',
    /**
     * Pattern used to parse/format dates.
     *
     * @var {String}
     */
    DATE_FORMAT: 'DD-MM-YYYY',
    /**
     * Whether debug messages shall be displayed in the browser's console.
     *
     * @var {String}
     */
    DEBUG: false,
    /**
     * Default page size in list views.
     *
     * @var {Number}
     */
    DEFAULT_PAGE_SIZE: 50,
    /**
     * Path to the endpoint for domain management.
     *
     * @var {String}
     */
    DOMAIN_PATH: ADMIN_API_PATH + '/domain/:id',
    /**
     * Path to the endpoint for the management of site attachments.
     *
     * @var {String}
     */
    EQUIPMENT_ATTACHMENT_PATH: ADMIN_API_PATH + '/equipment/:equipmentId/attachment/:id',
    /**
     * Path to the endpoint for equipment management.
     *
     * @var {String}
     */
    EQUIPMENT_PATH: ADMIN_API_PATH + '/equipment/:id',
    /**
     * Path to the endpoint for equipment template management.
     *
     * @var {String}
     */
    EQUIPMENT_TEMPLATE_PATH: ADMIN_API_PATH + '/equipment-template/:id',
    /**
     * Path to the endpoint for exports.
     *
     * @var {String}
     */
    EXPORTS_PATH: ADMIN_API_PATH + '/exports/:id',
    /**
     * Path to the endpoint for exports creation.
     *
     * @var {String}
     */
    EXPORTS_CREATE_PATH: '/create/:type',
    /**
     * Path to the endpoint for exports creation.
     *
     * @var {String}
     */
    EXPORTS_STATUS_PATH: '/status/:fileId',
    /**
     * Path to the endpoint for downloading exports.
     *
     * @var {String}
     */
    EXPORTS_DOWN_PATH: '/download/:fileId',
    /**
     * Sub-path to a find endpoint.
     *
     * @var {String}
     */
    FIND_PATH: '/find',
    FIND_LIGHT_PATH: '/find-light',
    /**
     * Sub-path to a count endpoint.
     *
     * @var {String}
     */
    COUNT_PATH: '/count',
    /**
     * Name of the event dispatched when an HTTP response has status 403.
     *
     * @var {String}
     */
    FORBIDDEN_EVENT_NAME: 'http-forbidden-event',
    /**
     * Path to the endpoint for GRT management.
     *
     * @var {String}
     */
    GRT_PATH: ADMIN_API_PATH + '/grt/:id',
    /**
     * Path to the endpoint for policies management between sites and GRTs.
     *
     * @var {String}
     */
    GRT_POLICY_PATH: ADMIN_API_PATH + '/grt-policy/:id',
    /**
     * Application language.
     *
     * @var {String}
     */
    LANG: 'fr',
    /**
     * URL of the localization service.
     *
     * @var {String}
     */
    LOCALIZATION_URL: 'https://nominatim.openstreetmap.org/search',
    /**
     * Path to the login service.
     *
     * @var {String}
     */
    LOGIN_PATH: AUTH_API_PATH + '/login',
    /**
     * Path to the logout service.
     *
     * @var {String}
     */
    LOGOUT_PATH: AUTH_API_PATH + '/logout',
    /**
     * Sub-path to retrieve metrics.
     *
     * @var {String}
     */
    METRICS_PATH: '/metrics',
    /**
     * Level used to notify information.
     *
     * @var {integer}
     */
    NOTIFIER_LEVEL_INFO: 0,
    /**
     * Level used to notify warnings.
     *
     * @var {integer}
     */
    NOTIFIER_LEVEL_WARN: 1,
    /**
     * Level used to notify errors.
     *
     * @var {integer}
     */
    NOTIFIER_LEVEL_ERROR: 2,
    /**
     * Name of the event dispatched to display a notification.
     *
     * @var {String}
     */
    NOTIFICATION_EVENT_NAME: 'notification-event',
    /**
     * Options to change page size, when enabled in a list view.
     *
     * @var {Number}
     */
    PAGE_SIZE_OPTIONS: [10, 50, 100],
    /**
     * Path to the endpoint for the management of preventive sheet attachments.
     *
     * @var {String}
     */
    PREVENTIVE_SHEET_ATTACHMENT_PATH: ADMIN_API_PATH + '/preventive-sheet/:preventiveSheetId/attachment/:id',
    /**
     * Path to the endpoint for exporting a preventive sheets file.
     *
     * @var {String}
     */
    PREVENTIVE_SHEET_EXPORT_PATH: '/export/:type',
    /**
     * Path to the endpoint for importing a preventive sheets file.
     *
     * @var {String}
     */
    PREVENTIVE_SHEET_IMPORT_PATH: '/import/:type',
    /**
     * Path to the endpoint for preventive sheet management.
     *
     * @var {String}
     */
    PREVENTIVE_SHEET_PATH: ADMIN_API_PATH + '/preventive-sheet/:id',
    /**
     * Path to the endpoint for preventive sheet template management.
     *
     * @var {String}
     */
    PREVENTIVE_SHEET_TEMPLATE_PATH: ADMIN_API_PATH + '/preventive-sheet-template/:id',
    /**
     * Path to the endpoint for the management of profiles.
     *
     * @var {String}
     */
    PROFILE_PATH: ADMIN_API_PATH + '/profile/:id',
    /**
     * Path to the endpoint to reopen an action request.
     *
     * @var {String}
     */
    REOPEN_ACTION_REQUEST_PATH: '/reopen',
    /**
     * Sub-path to a search endpoint.
     *
     * @var {String}
     */
    SEARCH_PATH: '/search',
    /**
     * Path to the endpoint for the management of site attachments.
     *
     * @var {String}
     */
    SITE_ATTACHMENT_PATH: ADMIN_API_PATH + '/site/:siteId/attachment/:id',
    /**
     * Path to the endpoint for site management.
     *
     * @var {String}
     */
    SITE_PATH: ADMIN_API_PATH + '/site/:id',
    /**
     * Path to the endpoint for statistics management.
     *
     * @var {String}
     */
    STATISTICS_PATH: ADMIN_API_PATH + '/statistics/:id',
    /**
     * Name of the event dispatched when an HTTP response has status 401.
     *
     * @var {String}
     */
    UNAUTHORIZED_EVENT_NAME: 'http-unauthorized-event',
    /**
     * Name of the event dispatched when an HTTP response has an unexpected (not managed) status.
     *
     * @var {String}
     */
    UNEXPECTED_STATUS_EVENT_NAME: 'http-unexpected-status-event',
    /**
     * Maximum size (MB) of an uploaded file (keep consistent with the same parameters backend-side).
     *
     * @var {Number}
     */
    UPLOAD_MAX_FILE_SIZE: 5,
    /**
     * Pattern used to parse/format fields containing a week of year.
     *
     * @var {String}
     */
    WEEK_OF_YEAR_FORMAT: 'GGGG-[S]WW'
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/Configuration.js